import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const cancelSupportV2Migration = {
  name: "cancelSupportV2Migration" as const,
  input: z.object({
    teamId: zExt.objectId(),
    workflowId: z.string().optional(),
  }),
  output: z.object({ status: z.literal("cancelled"), workflowId: z.string() }),
};
